import React, {CSSProperties} from "react";
import styled, {keyframes} from "styled-components";

export const LoadingIcon: React.FC<{ size?: number}> = ({size = 128}) => {

  return (
    <StyledLoadingRing size={size}>
        <StyledRing index={0} size={size}/>
        <StyledRing index={1} size={size}/>
        <StyledRing index={2} size={size}/>
        <StyledRing index={3} size={size}/>
    </StyledLoadingRing>
  )
}

const StyledLoadingRing = styled.div<{size: number}>`
  display: inline-block;
  position: relative;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
`

const rotate = keyframes`
  0% {
        transform: rotate(0deg);
   }
  100% {
      transform: rotate(360deg);
  }
`;

const StyledRing = styled.div<{size, index}>`
  width:  ${props => props.size}px;
  height:  ${props => props.size}px;
  margin: ${props => Math.sqrt(props.size)}px;
  border: ${props => Math.sqrt(props.size)}px solid;

  box-sizing: border-box;
  display: block;
  position: absolute;
  border-radius: 50%;
  animation: ${rotate} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  animation-delay: ${props => ["0", "-0.45s", "-0.3s", "-0.15s"][props.index]};
  border-color: ${props => props.index % 2 === 0? "#3F90B5" : "transparent"} transparent transparent transparent;
`
